import React, { KeyboardEvent } from 'react'
import { Icons } from '../../../types/enums'
import { ReactBaseElement } from '../../../types/react'
import { StyledError } from '../../styled/Error'
import Icon from '../Icon'
import {
  StyledInputContainer,
  StyledTextContainer,
  StyledLabel,
  StyledText,
} from './styled'

type InputProps = {
  label?: string
  placeholder?: string
  required?: boolean
  autocomplete?: string
  error?: string
  type?: 'text' | 'password' | 'email' | 'number'
  max?: string
  preIcon?: Icons
  afterIcon?: Icons
  maxLength?: number
  minLength?: number
  value?: string
  disabled?: boolean
  formatter?: 'uppercase' | 'lowercase'
  onChange?: React.ReactEventHandler
  onBlur?: React.ReactEventHandler
} & ReactBaseElement

const Formatter = {
  uppercase: (event: KeyboardEvent<HTMLInputElement>) => {
    return (event.currentTarget.value = event.currentTarget.value.toUpperCase())
  },
  lowercase: (event: KeyboardEvent<HTMLInputElement>) => {
    return (event.currentTarget.value = event.currentTarget.value.toLowerCase())
  },
}

const Input = React.forwardRef(
  (props: InputProps, ref: React.Ref<HTMLInputElement>) => {
    const formatterHandler = props.formatter
      ? Formatter[props.formatter]
      : undefined

    return (
      <StyledInputContainer>
        {props.preIcon && <Icon name={props.preIcon} />}
        <StyledLabel>{props.label}</StyledLabel>
        <StyledTextContainer>
          <StyledText
            type={props.type || 'text'}
            max={props.max}
            placeholder={props.placeholder || '...'}
            required={props.required}
            autoComplete={props.autocomplete}
            ref={ref}
            onKeyUp={formatterHandler}
            maxLength={props.maxLength}
            minLength={props.minLength}
            onChange={props.onChange}
            onBlur={props.onBlur}
            defaultValue={props.value}
            disabled={props.disabled}
          />
          {props.error && <StyledError>{props.error}</StyledError>}
        </StyledTextContainer>
      </StyledInputContainer>
    )
  }
)

export default Input
